import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ACLNavModule } from './acl-nav/acl-nav.module';
import { ACLInfoService } from './acl-nav/services/acl-info.service';
import { AngularMaterialModule } from './angular-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import { TopnavInfoService } from './navigation/menuInterfaces/topnav-info.service';
import { NavigationModule } from './navigation/navigation.module';
import { ResetMyPasswordModule } from './reset-my-password/reset-my-password.module';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { environment } from 'src/environments/environment';
import { AclDataModule } from './acl-data/acl-data.module';
import { NgrxDataModule } from 'ngrx-data';
import { entityConfig } from './acl-data/entity-metadata';
import { KeepAliveModule } from './session/keep-alive/keep-alive.module';
import { FolderViewsModule } from './folder-views/folder-views.module';
import { DocumentAddModule } from './document-add/document-add.module';
import { SharedControlsModule } from './shared-controls/shared-controls.module';
import { ReportsModule } from './reports/reports.module';
import { DocumenteditModule } from './document-edit/document-edit.module';
import { BusinessOwnerModule } from './business-owner/business-owner.module';
import { AclSearchModule } from './acl-search/acl-search.module';
import { UserManagementModule } from './user-management/user-management.module';
import { LegalCounselModule } from './legal-counsel/legal-counsel.module';
import { PopupConfirmationComponent } from 'src/app/modal/popup-confirmation/popup-confirmation.component';
import { ModalModule } from './modal/modal.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NavigationModule,
        ACLNavModule,
        LoginModule.forRoot(),
        ResetMyPasswordModule,
        !environment.production // || true
            ? StoreDevtoolsModule.instrument({
                  maxAge: 500,
                  name: 'ACL Filenet',
              })
            : [],
        AclDataModule,
        KeepAliveModule,
        FolderViewsModule,
        DocumentAddModule,
        DocumenteditModule,
        SharedControlsModule,
        ReportsModule,
        BusinessOwnerModule,
        AclSearchModule,
        UserManagementModule,
        LegalCounselModule,
        ModalModule
    ],
    providers: [{ provide: TopnavInfoService, useClass: ACLInfoService }],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
